import React, { forwardRef } from 'react';
import { FloatingPortal } from '@floating-ui/react-dom-interactions';

type WritebackReportProps = React.HTMLAttributes<HTMLDivElement> & {
  isInsuranceVerificationReportV2Enabled?: boolean;
  PrintableReport: JSX.Element;
  mountTarget?: string;
};
const WritebackReport = forwardRef<HTMLDivElement, WritebackReportProps>(
  ({ isInsuranceVerificationReportV2Enabled, PrintableReport, mountTarget, ...rest }, ref) => {
    // mountTarget is provided as root for DXC but for inline it should be in vertical slider. Using floatingPortal for inline to render this outside of slider as slider is already fully loaded
    if (mountTarget) {
      return (
        <div ref={ref} {...rest}>
          {PrintableReport}
        </div>
      );
    }
    return (
      <FloatingPortal>
        <div ref={ref} {...rest}>
          {PrintableReport}
        </div>
      </FloatingPortal>
    );
  }
);
WritebackReport.displayName = 'WritebackReport';

export const WritebackReportContainer = React.memo(WritebackReport);
